// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".todo-empty-hint[data-v-2944c2b0]{font-size:13px;margin-bottom:16px;padding:0 24px;line-height:1.6}.todo-empty-actions .el-button[data-v-2944c2b0]{margin:4px 6px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
